<template>
  <div>
    <v-tooltip
      top
    >
      <template #activator="{ on, attrs }">
        <div
          class="text-center container-info"
          :class="{
            'is_current' : cycle.is_current
          }"
          v-bind="attrs"
          v-on="on"
        >
          <span
            class="rounded-circle d-inline-block p-1 p-sm-3 d-flex justify-content-center align-items-center border info-text"
            :style="cycle.is_current ? 'border-color: #423a6c!important': null"
            :class="{
              'gray--border' : !cycle.is_current,
            }"
          >
            <p class="text-center text-sm font-weight-bold">
              -
            </p>
          </span>
          <p class="text-center sub-text">
            M{{ moduleOrder }}
          </p>
        </div>
      </template>
      <p class="text-center m-0">
        {{ cycle.started ? 'Você não escolheu os módulos do ciclo' : 'Este ciclo de estudos ainda não está disponível' }}
      </p>
    </v-tooltip>
  </div>    
</template>
<script>
export default {
    props: {
        cycle: {
            type:Object,
            required:true,
        },
        moduleOrder: {
          required:true,
          type: Number,
        },
    }
}
</script>
